'use strict'

import nan from 'is-nan'
Number.isNaN = nan

export const isDefined = function(o) {
    return (typeof o !== 'undefined') && o !== null
}

export const isNumeric = function(n) {
    return isDefined(n) && !Number.isNaN(n) && (typeof n === 'number')
}

export const isString = function(s) {
    return isDefined(s) && (typeof s === 'string')
}

export const isArray = function(a) {
    return isDefined(a) && Array.isArray(a)
}

export const isObject = function(o) {
    return isDefined(o) && (typeof o === 'object') && !isArray(o)
}

export const isBoolean = function(b) {
    return isDefined(b) && (typeof b === typeof true)
}


// WEBPACK FOOTER //
// ./src/js/app/utilities/types.js